module.exports = __webpack_public_path__ + "img/Family Key.a489f426.png";